module.exports = __webpack_public_path__ + "static/media/welcome-to-community.bc093709.png";